import React, { useState, useEffect } from "react";
import Header from "../../../../Shared/Header/Default/Herader";
import Footer from "../../../../Shared/Footer/Default/Footer";

import NoInternetImg from "../../../../assets/images/Rpost/no-internet.png";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./Exception.css";
import { useSelector } from "react-redux";

let sessionExpireCount = 0;
const NoInternet = ({translationsMap:langTranslations}) => {
  let translationsMap = useSelector(
        (state) => state.languageTranslation.translationsMap
    );
    if(translationsMap && Object.keys(translationsMap).length === 0){
      translationsMap = {...langTranslations};
    }
  const { documentId, fileName } = useParams();
  const history = useNavigate();
  useEffect(() => { });

  window.history.forward();
  useEffect(() => {
    window.addEventListener('popstate', (e) => {
      window.history.go(1);
    });
  }, []);

  window.addEventListener("popstate", e => {
    window.history.go(0);
  });

  const [Reader_DocumentID, setReader_DocumentID] = useState("");
  const [Reader_EmailAdress, setReader_EmailAdress] = useState("");
  const [Reader_VerificationCode, setReader_VerificationCode] = useState("");
  const [Reader_VerificationCode_Header, setReader_VerificationCode_Header] =
    useState("");
  const [Reader_Authorize, setReader_Authorize] = useState("");
  const [Reader_VerificationCode_Message, setReader_VerificationCode_Message] =
    useState("");
  const [Reader_ClickHere, setReader_ClickHere] = useState("");
  const [Reader_AuthorizeFailure, setReader_AuthorizeFailure] = useState("");
  const [Reader_GetVerificationCode, setReader_GetVerificationCode] =
    useState("");
  const [
    Reader_VerificationCode_Instruction,
    setReader_VerificationCode_Instruction,
  ] = useState("");
  const [
    Reader_VerificationCode_Remember,
    setReader_VerificationCode_Remember,
  ] = useState("");
  const [Reader_PleaseGoBack, setReader_PleaseGoBack] = useState("");
  const [Reader_Submit, setReader_Submit] = useState("");
  const [Reader_ActualSize, setReader_ActualSize] = useState("");
  const [Reader_FitPage, setReader_FitPage] = useState("");
  const [Reader_FullWidth, setReader_FullWidth] = useState("");
  const [Reader_DistributionList, setReader_DistributionList] = useState("");
  const [Reader_SideNote, setReader_SideNote] = useState("");
  const [Reader_ReplyToOwner, setReader_ReplyToOwner] = useState("");
  const [Reader_Print, setReader_Print] = useState("");
  const [Reader_Zoom, setReader_Zoom] = useState("");
  const [Reader_EnterYourEmailAddress, setReader_EnterYourEmailAddress] =
    useState("");
  const [Reader_Email, setReader_Email] = useState("");
  const [Reader_Passcode, setReader_Passcode] = useState("");
  const [Reader_OK, setReader_OK] = useState("");
  const [Reader_Getpasscode, setReader_Getpasscode] = useState("");
  const [Reader_GetPasscode, setReader_GetPasscode] = useState("");
  const [
    Reader_EnterYourEmailAddressCode,
    setReader_EnterYourEmailAddressCode,
  ] = useState("");
  const [Reader_Cancel, setReader_Cancel] = useState("");
  const [Reader_DocumentExpired, setReader_DocumentExpired] = useState("");
  const [Reader_FailedVerifyCodeEmail, setReader_FailedVerifyCodeEmail] =
    useState("");
  const [Reader_Continue, setReader_Continue] = useState("");
  const [Reader_GeneralTermsFooter, setReader_GeneralTermsFooter] =
    useState("");
  const [Reader_GeneralTerms, setReader_GeneralTerms] = useState("");
  const [Reader_Patent, setReader_Patent] = useState("");
  const [Reader_CheckYourEmail, setReader_CheckYourEmail] = useState("");
  const [Reader_APasscodeEmailed, setReader_APasscodeEmailed] = useState("");
  const [Reader_AVerificationCodeEmailed, setReader_AVerificationCodeEmailed] =
    useState("");
  const [Reader_TryAgain, setReader_TryAgain] = useState("");
  const [Reader_DocumentRestrictedAccess, setReader_DocumentRestrictedAccess] =
    useState("");
  const [Reader_ReachedMaximumViews, setReader_ReachedMaximumViews] =
    useState("");
  const [
    Reader_DocumentIsNoLongerAvailable,
    setReader_DocumentIsNoLongerAvailable,
  ] = useState("");
  const [
    Reader_InactivityYourSessionWillEnd,
    setReader_InactivityYourSessionWillEnd,
  ] = useState("");
  const [Reader_Minutes, setReader_Minutes] = useState("");
  const [Reader_Seconds, setReader_Seconds] = useState("");
  const [Reader_SessionTimedOut, setReader_SessionTimedOut] = useState("");
  const [Reader_YouHaveBeenInactive, setReader_YouHaveBeenInactive] =
    useState("");
  const [Reader_ContinueReadingDocument, setReader_ContinueReadingDocument] =
    useState("");
  const [
    Reader_PrintingDocumentIsNotPermitted,
    setReader_PrintingDocumentIsNotPermitted,
  ] = useState("");
  const [Reader_ConfirmYourVote, setReader_ConfirmYourVote] = useState("");
  const [Reader_OnlyVoteOnce, setReader_OnlyVoteOnce] = useState("");
  const [Reader_Like, setReader_Like] = useState("");
  const [Reader_Dislike, setReader_Dislike] = useState("");
  const [Reader_Voting, setReader_Voting] = useState("");
  const [Reader_ProtectedDocument, setReader_ProtectedDocument] = useState("");
  const [Reader_ProtectedDocumentAccess, setReader_ProtectedDocumentAccess] =
    useState("");
  const [Reader_AllRightsReserved, setReader_AllRightsReserved] = useState("");
  const [Reader_Terms, setReader_Terms] = useState("");
  const [
    Reader_DocumentServerUnavailable,
    setReader_DocumentServerUnavailable,
  ] = useState("");
  const [
    Reader_InternetConnectionRequired,
    setReader_InternetConnectionRequired,
  ] = useState("");
  const [
    Reader_EnteredEmailIsNotReadersList,
    setReader_EnteredEmailIsNotReadersList,
  ] = useState("");
  const [Reader_FailedSendVerifyCode, setReader_FailedSendVerifyCode] =
    useState("");
  const [Reader_UserVerificationFailure, setReader_UserVerificationFailure] =
    useState("");
  const [Reader_DocName, setReader_DocName] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [Reader_EnterEmailGetPasscode, setReader_EnterEmailGetPasscode] =
    useState("");
  const [Reader_PleaseEnterSubject, setReader_PleaseEnterSubject] =
    useState("");
  const [Reader_EmailSuccessfullySent, setReader_EmailSuccessfullySent] =
    useState("");
  const [Reader_DigitalRightsManagement, setReader_DigitalRightsManagement] =
    useState("");
  const [Reader_ProtectedDocumentViewer, setReader_ProtectedDocumentViewer] =
    useState("");
  const [Reader_ViewDistributionList, setReader_ViewDistributionList] =
    useState("");
  const [Reader_UsersList, setReader_UsersList] = useState("");
  const [Reader_ViewSideNote, setReader_ViewSideNote] = useState("");
  const [Reader_NoteFrom, setReader_NoteFrom] = useState("");
  const [Reader_ReplyToDocument, setReader_ReplyToDocument] = useState("");
  const [Reader_ClickToPrint, setReader_ClickToPrint] = useState("");
  const [Reader_Send, setReader_Send] = useState("");
  const [Reader_Message, setReader_Message] = useState("");
  const [Reader_Subject, setReader_Subject] = useState("");
  const [Reader_ToAddress, setReader_ToAddress] = useState("");
  const [Reader_YouWillLoggedIn, setReader_YouWillLoggedIn] = useState("");
  const [Reader_ClickToVote, setReader_ClickToVote] = useState("");
  const [Reader_DocumentHasNoAccess, setReader_DocumentHasNoAccess] =
    useState("");
  const [Reader_AccessDocument, setReader_AccessDocument] = useState("");
  const [
    Reader_SessionExpiredAccessDocument,
    setReader_SessionExpiredAccessDocument,
  ] = useState("");
  const [Reader_PleaseTryAgain, setReader_PleaseTryAgain] = useState("");
  const [Reader_CheckYourConnection, setReader_CheckYourConnection] =
    useState("");
  const [Reader_LegalNotices, setReader_LegalNotices] = useState("");
  const [Reader_ClickServiceLevelTerms, setReader_ClickServiceLevelTerms] =
    useState("");
  const [Reader_OtherService, setReader_OtherService] = useState("");

  if (sessionExpireCount == 0) {
    sessionExpireCount = 1;
    //getLanguageTranslations();
  }
  // async function getLanguageTranslations() {
  //   const browserlanguage = window.navigator.language;
  //   const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId}/${browserlanguage}`;
  //   let json;
  //   try {
  //     var res = await fetch(url);
  //     json = await res.json();
  //     console.log(json);
  //     //setLanguageTranslations(json.data);
  //     json.data.forEach((element) => {
  //       if (element.id === "2AC6EFF9-AF8B-4D36-8ABC-0A24B1C56F56")
  //         setReader_DocumentID(element.description);
  //       else if (element.id === "9BA629FE-2BA0-4740-89DC-167FCD3CA4C4")
  //         setReader_EmailAdress(element.description);
  //       else if (element.id === "3B344AE3-080C-4DFF-B17F-177BCB8D6A15")
  //         setReader_VerificationCode(element.description);
  //       else if (element.id === "8CA84CC8-46EE-4009-8EE0-1A9E11571EC8")
  //         setReader_VerificationCode_Header(element.description);
  //       else if (element.id === "F07FC5A9-C71D-4E63-911D-255E1544F3EB")
  //         setReader_Authorize(element.description);
  //       else if (element.id === "A4598B68-CC37-4B4D-9502-2A839C2C4865")
  //         setReader_VerificationCode_Message(element.description);
  //       else if (element.id === "7E85F861-F0E2-4BEC-92C4-2AEFF225FD6D")
  //         setReader_ClickHere(element.description);
  //       else if (element.id === "BF02D851-9481-4215-8EDD-2C4F1D1A14F5")
  //         setReader_AuthorizeFailure(element.description);
  //       else if (element.id === "B9272BCA-CFE7-4AA6-A530-30F2CC8377C2")
  //         setReader_GetVerificationCode(element.description);
  //       else if (element.id === "ECFD0FAA-B485-4499-9966-3A60FAB1ACE5")
  //         setReader_VerificationCode_Instruction(element.description);
  //       else if (element.id === "21E54828-A57B-4935-BBD5-40F08BD6F130")
  //         setReader_VerificationCode_Remember(element.description);
  //       else if (element.id === "BF69DF0D-8FF5-4555-AEC6-447F223E3AD6")
  //         setReader_PleaseGoBack(element.description);
  //       else if (element.id === "998BBBEF-9B6E-437A-80DC-56621DCED16D")
  //         setReader_Submit(element.description);
  //       else if (element.id === "5C20C8C9-C580-43A4-9E18-577A1F4E431C")
  //         setReader_ActualSize(element.description);
  //       else if (element.id === "8BCEBAA5-21F8-4D04-89D4-5A76836CB327")
  //         setReader_FitPage(element.description);
  //       else if (element.id === "294EBBB5-D0FA-42B8-B3AD-5F549463AAFD")
  //         setReader_FullWidth(element.description);
  //       else if (element.id === "BFE1787E-D04C-494C-A9E5-62496FA3FE08")
  //         setReader_DistributionList(element.description);
  //       else if (element.id === "AA313936-D9D9-408B-BBDB-6A8CE6CABB08")
  //         setReader_SideNote(element.description);
  //       else if (element.id === "7F73F129-096E-4BBA-B731-7A189872F835")
  //         setReader_ReplyToOwner(element.description);
  //       else if (element.id === "326A65C1-89D3-4554-ADAD-7B7E9B08E42C")
  //         setReader_Print(element.description);
  //       else if (element.id === "2FDC29C8-1A0D-4EED-9385-7F8CDFBB6A0F")
  //         setReader_Zoom(element.description);
  //       else if (element.id === "AE91A15B-35AF-480E-9250-8A65A062A596")
  //         setReader_EnterYourEmailAddress(element.description);
  //       else if (element.id === "B0C2990F-CDE0-45BE-B7DC-8C9B52338536")
  //         setReader_Email(element.description);
  //       else if (element.id === "6AB42951-6546-44B6-9750-C94B8BC3FA95")
  //         setReader_Passcode(element.description);
  //       else if (element.id === "442CE6A9-22AF-408A-A2AA-92EE577999A7")
  //         setReader_OK(element.description);
  //       else if (element.id === "B6785E69-9416-47A2-BDFA-9537E6A60591")
  //         setReader_Getpasscode(element.description);
  //       else if (element.id === "7754F0CA-053D-4203-9261-9A8D4BE56746")
  //         setReader_GetPasscode(element.description);
  //       else if (element.id === "818E8449-D5EE-4820-A646-9AC8D1D4F984")
  //         setReader_EnterYourEmailAddressCode(element.description);
  //       else if (element.id === "DC458BAF-A9A8-403A-913A-A7C7C417A578")
  //         setReader_Cancel(element.description);
  //       else if (element.id === "434DDE98-2BB2-4A7C-82DE-AB6D6DEE9E7B")
  //         setReader_DocumentExpired(element.description);
  //       else if (element.id === "BBB2A9AA-0CBB-4175-B827-AC3FAF91B20C")
  //         setReader_FailedVerifyCodeEmail(element.description);
  //       else if (element.id === "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1")
  //         setReader_Continue(element.description);
  //       else if (element.id === "A43B773D-45DD-4968-809E-AE3271A639B3")
  //         setReader_GeneralTermsFooter(element.description);
  //       else if (element.id === "C920E4EB-129F-4EDC-BE19-B1CA133E0A19")
  //         setReader_GeneralTerms(element.description);
  //       else if (element.id === "674C0F1F-6EA4-443A-BD38-B47030C2ADA9")
  //         setReader_Patent(element.description);
  //       else if (element.id === "6F6B09DC-D705-4F70-A5AD-BA539115C23F")
  //         setReader_CheckYourEmail(element.description);
  //       else if (element.id === "1E0B6C7D-24EB-4697-8F00-CB3B3EECC1EE")
  //         setReader_APasscodeEmailed(element.description);
  //       else if (element.id === "809D3F1D-D2E6-475D-BEAB-CE7A6795C147")
  //         setReader_AVerificationCodeEmailed(element.description);
  //       else if (element.id === "3387D8D0-BDDB-4FA5-BE71-DBADEC20A0D4")
  //         setReader_TryAgain(element.description);
  //       else if (element.id === "AD9099E6-C2C1-480E-96F4-DC148642A783")
  //         setReader_DocumentRestrictedAccess(element.description);
  //       else if (element.id === "D22EFEBA-D89A-49E8-B544-DF728B2EC62C")
  //         setReader_ReachedMaximumViews(element.description);
  //       else if (element.id === "0FCF576E-DB5C-4246-B05F-E88215C69731")
  //         setReader_DocumentIsNoLongerAvailable(element.description);
  //       else if (element.id === "697A33A8-5735-4064-9866-E95832CC8303")
  //         setReader_InactivityYourSessionWillEnd(element.description);
  //       else if (element.id === "33903FCD-2591-469E-8891-E9B6F0746E3B")
  //         setReader_Minutes(element.description);
  //       else if (element.id === "12BCE010-F096-41B5-AE4F-EA98B2310538")
  //         setReader_Seconds(element.description);
  //       else if (element.id === "F84C536A-E172-4C14-B827-F06DC17E31D0")
  //         setReader_SessionTimedOut(element.description);
  //       else if (element.id === "1A9D7565-3DEB-4AF1-A60E-F5B08F62C834")
  //         setReader_YouHaveBeenInactive(element.description);
  //       else if (element.id === "817258A6-5338-4508-8733-F6437E942CBD")
  //         setReader_ContinueReadingDocument(element.description);
  //       else if (element.id === "FFDF3914-4CC6-4C02-A6D2-FC05F2A375F7")
  //         setReader_PrintingDocumentIsNotPermitted(element.description);
  //       else if (element.id === "27FF1441-6850-4601-B2DD-075D3AD01AEE")
  //         setReader_ConfirmYourVote(element.description);
  //       else if (element.id === "771A386D-B1F0-485C-B448-1D340209D580")
  //         setReader_OnlyVoteOnce(element.description);
  //       else if (element.id === "3341B4F5-4B0F-4BB1-A04F-46CFB98C803F")
  //         setReader_Like(element.description);
  //       else if (element.id === "CA3DB143-B23C-4351-B635-5E636C37664C")
  //         setReader_Dislike(element.description);
  //       else if (element.id === "E06FF01E-F57C-4337-94E5-986B31AB1D41")
  //         setReader_Voting(element.description);
  //       else if (element.id === "E9D32EC4-BFC1-49E0-9A11-5657B5AD4987")
  //         setReader_ProtectedDocumentAccess(element.description);
  //       else if (element.id === "007CF6B5-9AED-4956-A5E8-2D27F40795F9")
  //         setReader_ProtectedDocument(element.description);
  //       else if (element.id === "EEC944B7-CF89-4073-AAB2-38C5CD4C388C")
  //         setReader_AllRightsReserved(element.description);
  //       else if (element.id === "53708ED8-B8C6-4246-AB81-76F49FAC7E1C")
  //         setReader_Terms(element.description);
  //       else if (element.id === "AB232AED-8FB4-4E72-A550-DC57477EA1BE")
  //         setReader_DocumentServerUnavailable(element.description);
  //       else if (element.id === "977B4401-07E3-4848-870E-D7519A89BE0A")
  //         setReader_InternetConnectionRequired(element.description);
  //       else if (element.id === "A46D6AA3-7989-468F-85FE-AA9CA637A63A")
  //         setReader_EnteredEmailIsNotReadersList(element.description);
  //       else if (element.id === "D4FE0525-1829-48FE-87F7-D248053B5BF8")
  //         setReader_FailedSendVerifyCode(element.description);
  //       else if (element.id === "A399DFA9-C65E-40CC-A51B-7D3825270DB6")
  //         setReader_UserVerificationFailure(element.description);
  //       else if (element.id === "01464BDE-1F06-4CE4-B382-0D12FD415573")
  //         setReader_DocName(element.description);
  //       else if (element.id === "0198A1C3-A616-4383-9CA1-2B686E7B2161")
  //         setReader_ID(element.description);
  //       else if (element.id === "B1B1DD59-8DE0-4F34-914D-3BC9BF7C549A")
  //         setReader_EnterEmailGetPasscode(element.description);
  //       else if (element.id === "4D24E110-C95C-44DC-8DE0-586EEFD43901")
  //         setReader_PleaseEnterSubject(element.description);
  //       else if (element.id === "55F7F90F-5079-44D9-80C6-75E5CA0F3D8E")
  //         setReader_EmailSuccessfullySent(element.description);
  //       else if (element.id === "2B5CD1B8-E2C1-40FE-8657-81297F664F97")
  //         setReader_DigitalRightsManagement(element.description);
  //       else if (element.id === "384088DF-3A77-4AE7-9B85-2349394EFC30")
  //         setReader_ProtectedDocumentViewer(element.description);
  //       else if (element.id === "BCE385E2-E768-479E-8A28-7D90B153347E")
  //         setReader_ViewDistributionList(element.description);
  //       else if (element.id === "549961D1-C11B-4EF6-BFFC-8DC5BB995463")
  //         setReader_UsersList(element.description);
  //       else if (element.id === "F4CE40B3-2391-4A0B-BBB9-930710845A68")
  //         setReader_ViewSideNote(element.description);
  //       else if (element.id === "56B9CC7C-747E-420E-A5ED-B3F1C0A73D3B")
  //         setReader_NoteFrom(element.description);
  //       else if (element.id === "F8109066-3DEF-4FD3-A4A3-C6170D9D1CF8")
  //         setReader_ReplyToDocument(element.description);
  //       else if (element.id === "3C7C0F84-FC5E-416A-9E6B-110606DBE2DF")
  //         setReader_ClickToPrint(element.description);
  //       else if (element.id === "BA8DC442-BB68-4D4F-978F-64DE3B71D467")
  //         setReader_Send(element.description);
  //       else if (element.id === "EF11C8AF-E646-493F-9016-583861FF6008")
  //         setReader_Message(element.description);
  //       else if (element.id === "C1988359-42CB-41A2-8336-C7767AAE9406")
  //         setReader_Subject(element.description);
  //       else if (element.id === "4E086CF8-AAD1-4717-8CA4-E3C22EFC6256")
  //         setReader_ToAddress(element.description);
  //       else if (element.id === "39265EFF-9C1B-49D3-98BA-7110FA4AEB62")
  //         setReader_YouWillLoggedIn(element.description);
  //       else if (element.id === "CCC0FADA-9CD5-4BFD-BAEB-7EE9B9677DF1")
  //         setReader_ClickToVote(element.description);
  //       else if (element.id === "3D2F2837-9063-40CB-AF53-5E7790373EA1")
  //         setReader_DocumentHasNoAccess(element.description);
  //       else if (element.id === "0F8665A9-F7F3-4D07-8F64-E0F0576079D0")
  //         setReader_AccessDocument(element.description);
  //       else if (element.id === "F99602CF-AF87-4DE1-A20B-E82A064F1B51")
  //         setReader_SessionExpiredAccessDocument(element.description);
  //       else if (element.id === "8B569962-71C7-48A6-BDD0-43C37B489D91")
  //         setReader_PleaseTryAgain(element.description);
  //       else if (element.id === "5CA9B16D-46A7-43E9-9B3D-9076CB4C18B9")
  //         setReader_CheckYourConnection(element.description);
  //       else if (element.id === "C24DB5B6-951E-4E47-AEE1-A401FE85A7C3")
  //         setReader_LegalNotices(element.description);
  //       else if (element.id === "511A78A4-02CB-4EF0-A05C-3A8FC1EB92A7")
  //         setReader_ClickServiceLevelTerms(element.description);
  //       else if (element.id === "0C6DC977-FFCA-45BD-83DA-CD11AC5B7E6B")
  //         setReader_OtherService(element.description);
  //     });
  //   } catch (error) {
  //     console.log("error in languagetranslations: " + error);
  //   }
  // }

  const gotoindex = async (event) => {
    event.preventDefault();
    localStorage.setItem("defaultScreen", "1");
    history(`/code/${documentId}/0/${fileName}`);
  };
  return (
    <>
      <Header
        Reader_ProtectedDocumentAccess={translationsMap.Reader_ProtectedDocumentAccess}
      ></Header>
      <main className="rpdFont form-signin">
        <div className="user_card internet-padding">
          <div className="rpdFont d-flex justify-content-center">
            <img src={NoInternetImg} alt="" className="check mb-4" />
          </div>

          <div className="d-flex flex-column justify-content-center mb-3">
            <p className="rpdFont text-center font-1em mb-1 rd-text">
              {/* {Reader_InternetConnectionRequired} */}
              Document cannot currently authenticate due to your lack of Internet connection.
            </p>
            <p className="rpdFont text-center font-1rem text-nowrap1 rd-text">
              {/* {Reader_CheckYourConnection} */}
              Please check your connectivity and try again.
            </p>
          </div>

          <div
            className="rpdFont rpd-documentId"
            style={{
              fontFamily: "Calibri",
              fontSize: "8pt",
              color: "#7F7F7F",
              textAlign: "right",
              marginBottom: "-26px",
            }}
          >
            {/* {Reader_DocumentID}: {documentId} */}
            Document ID: {documentId}
          </div>
        </div>
      </main>
      <Footer
        Reader_GeneralTermsFooter={translationsMap.Reader_GeneralTermsFooter}
        Reader_LegalNotices={translationsMap.Reader_LegalNotices}
        Reader_ClickServiceLevelTerms={translationsMap.Reader_ClickServiceLevelTerms}
        Reader_Patent={translationsMap.Reader_Patent}
        Reader_OtherService={translationsMap.Reader_OtherService}
      ></Footer>
    </>
  );
};

export default NoInternet;
